import { createFileRoute } from '@tanstack/react-router'
import TokenDebugger from '@/components/debug/TokenDebugger'

export const Route = createFileRoute('/debug-token')({
  component: DebugTokenComponent,
})

function DebugTokenComponent() {
  return <TokenDebugger />
}
